module.exports = __webpack_public_path__ + "static/media/buildingConstruction6.e7bd14c9.jpg";